import { NgModule } from '@angular/core';

import { ButtonNewModule } from '@recruitee/user-interface';

import { WysiwygInlineButtonModule } from '../../wysiwyg-inline-button/wysiwyg-inline-button.module';
import { RedactorInsertsDialogComponent } from './redactor-inserts-dialog/redactor-inserts-dialog.component';
import { WysiwygLinkComponent } from './wysiwyg-link.component';

@NgModule({
  imports: [WysiwygInlineButtonModule, ButtonNewModule],
  declarations: [WysiwygLinkComponent, RedactorInsertsDialogComponent],
  exports: [WysiwygLinkComponent, RedactorInsertsDialogComponent],
})
export class WysiwygLinkModule {}
export { WysiwygLinkComponent } from './wysiwyg-link.component';
export { RedactorInsertsDialogComponent } from './redactor-inserts-dialog/redactor-inserts-dialog.component';
